// ─── Information Pillar: Data Object ───────────────────────────────────────

import type { DataObject } from '../../graphql/types';
import { createEntityCrudClient } from './crudFactory';

export interface CreateDataObjectInput {
  name: string;
  description?: string;
  domainId: string;
  objectType: string;
  classification: string;
  containsPII?: boolean;
  containsPCI?: boolean;
  containsPHI?: boolean;
  encryptionRequired?: boolean;
  maskingRequired?: boolean;
  systemOfRecord?: string;
  isGoldenRecord?: boolean;
  lifecycleStatus?: string;
  retentionPeriodDays?: number;
  tags?: string[];
  notes?: string;
  documentationUrl?: string;
}

export interface UpdateDataObjectInput {
  name?: string;
  description?: string;
  objectType?: string;
  classification?: string;
  containsPII?: boolean;
  containsPCI?: boolean;
  containsPHI?: boolean;
  encryptionRequired?: boolean;
  maskingRequired?: boolean;
  systemOfRecord?: string;
  isGoldenRecord?: boolean;
  lifecycleStatus?: string;
  retentionPeriodDays?: number;
  tags?: string[];
  notes?: string;
  documentationUrl?: string;
}

const client = createEntityCrudClient<DataObject, CreateDataObjectInput, UpdateDataObjectInput>(
  '/data-objects'
);

export async function createDataObject(input: CreateDataObjectInput): Promise<DataObject> {
  return client.create(input);
}

export async function updateDataObject(
  dataObjectId: string,
  input: UpdateDataObjectInput
): Promise<DataObject> {
  return client.update(dataObjectId, input);
}

export async function deleteDataObject(
  dataObjectId: string,
  hardDelete: boolean = false
): Promise<void> {
  return client.remove(dataObjectId, hardDelete);
}
